import { observer } from "mobx-react-lite";

import { Sidebar } from "@/components/sidebar";
import { Dropdown } from "@/components/sidebar/Dropdown";
import DarkThemeIcon from "@/components/sidebar/theme-switcher/DarkTheme.svg";
import LightThemeIcon from "@/components/sidebar/theme-switcher/LightTheme.svg";
import SystemThemeIcon from "@/components/sidebar/theme-switcher/SystemTheme.svg";
import { useStore } from "@/store/RootStoreProvider";

import type { DocumentModel } from "@/models/DocumentModel";

type Props = {
  doc: DocumentModel;
};

export const CodeThemeSwitcher = observer(function CodeThemeSwitcher({ doc }: Props) {
  const { userSettings } = useStore();
  const {
    editor: { tiptap },
  } = doc;
  if (!tiptap) {
    return null;
  }

  function getCurrentThemeIcon() {
    if (userSettings.codeTheme) {
      return userSettings.codeTheme === "dark" ? <DarkThemeIcon /> : <LightThemeIcon />;
    }

    return <SystemThemeIcon />;
  }

  const icon = getCurrentThemeIcon();

  const items = [
    {
      title: "Light",
      icon: <LightThemeIcon />,
      active: userSettings.codeTheme === "light",
      onClick: () => {
        userSettings.setCodeTheme("light");
      },
    },
    {
      title: "Dark",
      icon: <DarkThemeIcon />,
      active: userSettings.codeTheme === "dark",
      onClick: () => {
        userSettings.setCodeTheme("dark");
      },
    },
    {
      title: "Default",
      icon: <SystemThemeIcon />,
      disabled: !userSettings.codeTheme,
      onClick: () => {
        userSettings.setCodeTheme(null);
      },
    },
  ];

  return (
    <Dropdown
      toggleButtonComponent={
        <Sidebar.ToggleButton as="div" icon={icon} tooltipTitle="Code block theme" />
      }
      items={items}
    />
  );
});
